import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-borderDark bg-bgDark/90 backdrop-blur-sm">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img 
            src="/logo.png" 
            alt="Logo" 
            className="w-10 h-10 rounded-xl shadow-sm object-contain bg-cardBg p-1" 
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <span className="text-xl font-bold tracking-tight text-textMain">
            Browser Lock
          </span>
        </Link>
      </div>
    </header>
  );
};

export default Header;